<!-- <div class="cheddar-container" (click)="cheddarClicked()" #cheddarContainer> -->
<div class="cheddar-outer-container">
  <div class="cheddar-container" #cheddarContainer>
    <div class="cheddar-content">
      <!-- componente cheddar -->
    </div>
  </div>
</div>
